import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
    LayoutDashboard, PlusCircle, Briefcase, CheckSquare,
    BarChart2, Settings, HelpCircle, Menu, X, Home, User
} from 'lucide-react';
import { useApp } from '../../context/AppContext';

const Layout = ({ children }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const { businesses, activeBusinessId, setActiveBusinessId } = useApp();

    const menu = [
        { icon: LayoutDashboard, label: 'Dashboard', path: '/app/dashboard' },
        { icon: PlusCircle, label: 'Builder Engine', path: '/app/builder' },
        { icon: Briefcase, label: 'Workspace', path: '/app/workspace' },
        { icon: CheckSquare, label: 'Tasks', path: '/app/tasks' },
        { icon: BarChart2, label: 'Analytics', path: '/app/analytics' },
        { icon: Settings, label: 'Settings', path: '/app/settings' },
        { icon: HelpCircle, label: 'Help & Support', path: '/app/help' },
    ];

    return (
        <div className="min-h-screen flex bg-bg text-slate-900 font-sans">
            {/* Sidebar */}
            <aside className={`fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-border transform transition-transform duration-300 md:translate-x-0 ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}`}>
                <div className="p-6 border-b border-border flex justify-between items-center">
                    {/* LOGO UPDATE */}
                    <div className="text-xl font-extrabold tracking-tight">
                        Auto<span className="text-primary">Inventor</span>
                    </div>
                    <button onClick={() => setMobileMenuOpen(false)} className="md:hidden text-slate-500"><X size={24} /></button>
                </div>

                {/* Business Switcher */}
                <div className="p-4">
                    <label className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block">Current Venture</label>
                    <select
                        className="w-full p-2 bg-slate-50 border border-border rounded-lg text-sm font-medium outline-none focus:border-primary"
                        value={activeBusinessId}
                        onChange={(e) => setActiveBusinessId(Number(e.target.value))}
                    >
                        {businesses.map(b => (
                            <option key={b.id} value={b.id}>{b.name}</option>
                        ))}
                    </select>
                </div>

                <nav className="flex-1 px-3 py-2 space-y-1 overflow-y-auto">
                    {menu.map((item) => {
                        const isActive = location.pathname === item.path;
                        return (
                            <Link key={item.path} to={item.path} onClick={() => setMobileMenuOpen(false)}
                                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${isActive ? 'bg-primary text-white shadow-md shadow-primary/20' : 'text-slate-600 hover:bg-slate-50'}`}>
                                <item.icon size={20} />
                                <span className="font-medium">{item.label}</span>
                            </Link>
                        );
                    })}
                </nav>

                <div className="p-4 border-t border-border">
                    <div className="flex items-center gap-3 mb-4">
                        <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-primary"><User size={16} /></div>
                        <div className="overflow-hidden">
                            <p className="text-sm font-medium truncate">Alex Founder</p>
                            <p className="text-xs text-slate-500 truncate">Pro Plan</p>
                        </div>
                    </div>
                    <button onClick={() => navigate('/')} className="flex items-center gap-2 text-sm text-slate-500 hover:text-primary w-full">
                        <Home size={16} /> Back to Home
                    </button>
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-1 md:ml-64 flex flex-col min-h-screen overflow-hidden">
                <header className="md:hidden h-16 bg-white border-b border-border flex items-center justify-between px-4 sticky top-0 z-40">
                    {/* MOBILE LOGO UPDATE */}
                    <div className="font-bold text-lg">AutoInventor</div>
                    <button onClick={() => setMobileMenuOpen(true)} className="p-2 text-slate-600"><Menu /></button>
                </header>
                <div className="flex-1 p-4 md:p-8 overflow-y-auto">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default Layout;
